export default __webpack_public_path__ + "static/media/bg.a114510f.png";